import { render, staticRenderFns } from "./AdmiralCheckbox.vue?vue&type=template&id=f8366b8e"
import script from "./AdmiralCheckbox.vue?vue&type=script&lang=ts"
export * from "./AdmiralCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./AdmiralCheckbox.vue?vue&type=style&index=0&id=f8366b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports